import React from 'react';
import PropTypes from 'prop-types';
import NumberDisplay from '../../../../components/number-display';

function NumberRenderer(props) {
  const {
    value, precision, suffix, suffixIsUnit,
    onClick, colDef, data,
  } = props;
  if (value === 0) {
    return (<span>0</span>);
  }
  return (
    <a href="" onClick={(e) => { e.stopPropagation(); e.preventDefault(); onClick(colDef.field, data); }}><NumberDisplay value={value} precision={precision} suffix={suffix} suffixIsUnit={suffixIsUnit} /></a>
  );
}

NumberRenderer.propTypes = {
  colDef: PropTypes.shape({
    field: PropTypes.string,
  }).isRequired,
  data: PropTypes.shape({}),
  value: PropTypes.number,
  precision: PropTypes.number,
  suffix: PropTypes.string,
  suffixIsUnit: PropTypes.bool,
  onClick: PropTypes.func,
};
NumberRenderer.defaultProps = {
  value: null,
  data: null,
  precision: 0,
  suffix: null,
  suffixIsUnit: false,
  onClick: () => {},
};

export default NumberRenderer;
